import React, { Component, Fragment } from 'react';
import { SidePanel } from '../../common/SidePanel';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { isNumber } from '../../utils/Validation';

export class PerkInProductAddEdit extends Component {
    static displayName = PerkInProductAddEdit.name;

    constructor(props) {
        super(props);

        this.state = {
            designerId: props.designerId,
            perkId: props.perkId,
            data: props.data,
            productList: props.productList,
            existListIds: props.existList.map(x => x.productId),
            error: null,
            complete: false,
            index: props.data?.index,
            id: props.data?.id,
            productId: isNumber(props.data?.productId) ? props.data?.productId : '',
            maxClaimInProduct: props.data?.maxClaimInProduct || '',
        };
        console.log(props.existList)
        console.log(props.productList)
        console.log(props.data)

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
    }

    handleInputChange(event) {
        const target = event.target;

        let value;
        switch (target.type) {
            case 'checkbox':
                value = target.checked;
                break;
            case 'file':
                value = target.files[0];
                break;
            default:
                value = target.value;
                break;
        }
        const name = target.name;

        this.setState({
            [name]: value
        });
    }


    handleSubmit(event) {
        event.preventDefault();

        console.log('submitting..');
        console.log(this.state);

        const { index, id, productId, maxClaimInProduct } = this.state;
        this.props.update({
            index,
            id,
            productId: isNumber(productId) ? parseInt(productId) : null,
            maxClaimInProduct: isNaN(parseInt(maxClaimInProduct)) ? null : parseInt(maxClaimInProduct)
        })

        this.props.onExited();
    }

    render() {
        let productOptionItems;
        
        if(isNaN(this.state.index)) {
            productOptionItems = this.state.productList
                .filter(item => !this.state.existListIds.includes(item.productId))
                .map((item) =>
                    <option key={item.productId}  value={item.productId}>{item.title}</option>
                );
        } else {
            productOptionItems = this.state.productList
                .filter(item => item.productId === this.state.data.productId)
                .map((item) =>
                    <option key={item.productId}  value={item.productId}>{item.title}</option>
                );
        };

        return (
            <SidePanel onExited={this.props.onExited}>
                <div>
                    <h1>{isNaN(this.state.index) ? 'New perk in item' : 'Edit perk in item'}</h1>
                    <p>Add the perk to your item.</p>
                    <Form onSubmit={this.handleSubmit}>

                        <FormGroup>
                            <Label for="ProductId">Item</Label>
                            <select
                                value={this.state.productId}
                                onChange={this.handleInputChange}
                                className="form-control"
                                id="ProductId"
                                disabled={isNaN(this.state.index) ? false : true}
                                name="productId" required>
                                <option value="">Select item</option>
                                {productOptionItems}
                            </select>
                            <FormText color="muted">
                                Select a item.
                            </FormText>
                        </FormGroup>

                        <FormGroup>
                            <Label for="MaxClaimInProduct">Max allowed claims</Label>
                            <Input type="number" name="maxClaimInProduct" id="MaxClaimInProduct"
                                placeholder=""
                                value={this.state.maxClaimInProduct}
                                maxLength="6"
                                onChange={this.handleInputChange}
                                style={{ maxWidth: '140px' }}
                                className="simpletxt"
                            />
                            <FormText color="muted">
                                Optional: setting the max allowed claims, or leaving this field empty will not restrict the number of claims allowed for this perk.
                            </FormText>
                        </FormGroup>

                        <Button className="mt-3" color="dark" size="sm">{isNaN(this.state.index) ? 'Add perk in item' : 'Edit perk in item'}</Button>
                    </Form>

                </div>
            </SidePanel>
        );
    }
}
